import React from 'react';
import Loader from 'react-loader';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  BASE_URL, createRequestProperties, downloadFile, installationDocumentRequestApi,
} from '../actions/helper';
import { enableSubNavbar, setSubNavbar } from '../actions/navbar';
import { getLocalizedName } from '../localization/LocalizedString';

class InstallationDocument extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      imageData: null,
      currentInstallationDocumentId: this.props.installationDocumentId,
      shipmentId: this.props.shipmentId,
      installationDocumentLoading: true,
      pdfName: null,
    };
  }

  componentDidMount() {
    this.updateNavbar(this.state.shipmentId);

    const urlParts = window.location.href.split('/');
    const shipmentId = urlParts[urlParts.length - 1];
    installationDocumentRequestApi(`/installationdocument/order/search/${shipmentId}`)
      .then((importedEditJson) => {
        if (importedEditJson.customer.pdfName !== undefined) {
          this.setState({ pdfName: importedEditJson.customer.pdfName });
        }
      }).catch((err) => toast.error(err.message));

    const getData = async () => {
      const imageData = await this.fetchImages(this.state.currentInstallationDocumentId);
      if (imageData != null) {
        this.setState({
          imageData,
        });
      }
    };
    getData();
  }

  updateNavbar(id) {
    const { enableSubNavbar, setSubNavbar, translate } = this.props;

    if (!id) {
      enableSubNavbar();
      return true;
    }
    setSubNavbar({
      title: [
        `${translate('service_report.column_task.shipmentId')}: ${id}`,
      ],
    });

    return id;
  }

  timeoutPromise(ms, promise) {
    return new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        reject(new Error('promise timeout'));
      }, ms);
      promise.then(
        (res) => {
          clearTimeout(timeoutId);
          resolve(res);
        },
        (err) => {
          clearTimeout(timeoutId);
          reject(err);
        },
      );
    });
  }

  async fetchImages(id) {
    try {
      const images = await this.timeoutPromise(30000, fetch(`${BASE_URL}/installationdocument/images/${id}`, createRequestProperties(null)));
      return await images.json();
    } catch (error) {
      this.setState({ installationDocumentLoading: false });
      return null;
    }
  }

  showInstallationDocumentImages = (id) => {
    const getData = async () => {
      const imageData = await this.fetchImages(id);
      console.log('Images Download finished');
      if (imageData != null) {
        this.setState({
          imageData,
        });
      }
    };
    getData();
  };

  createImageFromBase64 = (imageBase64) => {
    const byteCharacters = atob(imageBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const image = new Blob([byteArray], { type: 'image/jpeg' });
    return URL.createObjectURL(image);
  };

  render() {
    const { translate, currentLanguage } = this.props;
    const { imageData, pdfName } = this.state;
    const imageStyles = {
      paddingBottom: '10px',
      objectFit: 'contain',
      maxHeight: '600px',
      width: '100%',
      height: '100%',
    };

    const options = {
      lines: 13,
      length: 14,
      width: 7,
      radius: 21,
      scale: 1.00,
      corners: 1,
      color: '#000',
      opacity: 0.25,
      rotate: 0,
      direction: 1,
      speed: 1,
      trail: 60,
      fps: 20,
      position: 'relative',
    };

    return (
      <div>
        <div className="container">
          {pdfName !== null ? (
            <button onClick={() => {
              downloadFile(pdfName, '/installationdocument/report/pdf');
            }}
                    className="form-button-small form-input-shadow">
              {translate('service_report.column_task.downloadPDF')}
            </button>
          ) : ''}
          <div className="row">
            <div className="col-sm-6">
              <div className="installation-document-image-div">
                {(Array.isArray(imageData) && imageData !== 0) ? imageData.map((item) => (
                  <div>
                    <h3>{getLocalizedName(item, currentLanguage)}</h3>
                    {item.imageList.map((image) => (
                      <img alt=""
                           src={this.createImageFromBase64(image)}
                           style={imageStyles} />
                    ))}
                  </div>
                ))
                  : (
                    <div>
                      {this.state.installationDocumentLoading
                        ? (
                          <div className="installation-document-loader">
                            <Loader loaded={false} options={options} />
                          </div>
                        )
                        : (
                          <h4
                        className="primary-color">
                            {translate('new_task.could_not_load_images')}
                          </h4>
                        )}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state = {}, ownProps = {}) => {
  const {
    installationDocumentId,
    shipmentId,
    imageData,
  } = ownProps.params || {};

  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);

  return {
    installationDocumentId,
    shipmentId,
    imageData,
    translate: getTranslate(locale),
    currentLanguage: activeLanguage?.code || 'fi',
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  enableSubNavbar,
  setSubNavbar,
}, dispatch);

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
      <Component
                {...props}
                location={location}
                navigate={navigate}
                params={params} />
    );
  }
  return ComponentWithRouterProp;
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(InstallationDocument));
